export default "__VITE_ASSET__cNca2PsQ__"